import { Link, useLocation, useNavigate } from "react-router-dom";
import styles from "./Header.module.css";
import SearchBar from "./SearchBar";

const NAV_LINKS = [
  { label: "Concerts", to: "/search?category=cat_concerts" },
  { label: "Sports", to: "/search?category=cat_sports" },
  { label: "Theater", to: "/search?category=cat_theater" },
  { label: "Comedy", to: "/search?category=cat_comedy" },
  { label: "Family", to: "/search?category=cat_family" },
];

export default function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const onHome = location.pathname === "/";
  // Event detail pages have a colored hero banner — float the nav over it.
  const onEvent = location.pathname.startsWith("/events/");

  // Home: minimal — just the logo, transparent over the hero.
  if (onHome) {
    return (
      <header className={`${styles.header} ${styles.headerHome}`}>
        <div className={`container ${styles.inner}`}>
          <Link to="/" className={styles.logo} aria-label="Home">
            <span className={styles.logoMark} aria-hidden>
              ◆
            </span>
            <span className={styles.logoText}>tickets</span>
          </Link>
        </div>
      </header>
    );
  }

  return (
    <header
      className={`${styles.header} ${onEvent ? styles.headerOverHero : ""}`}
    >
      <div className={`container ${styles.inner}`}>
        <div className={styles.left}>
          <Link to="/" className={styles.logo} aria-label="Home">
            <span className={styles.logoMark} aria-hidden>
              ◆
            </span>
            <span className={styles.logoText}>tickets</span>
          </Link>

          <nav className={styles.nav} aria-label="Categories">
            {NAV_LINKS.map((link) => (
              <Link key={link.to} to={link.to} className={styles.navLink}>
                {link.label}
              </Link>
            ))}
          </nav>
        </div>

        <div className={styles.search}>
          <SearchBar
            compact
            onSubmit={(q) =>
              navigate(`/search?q=${encodeURIComponent(q)}`)
            }
          />
        </div>
      </div>
    </header>
  );
}
